/**
 * The default-language contract (backend AIE D21, dev-platform A0): in an ordered language list --
 * a tenant's `config.i18n.lang_enabled`, a tour's `available_langs` -- the LAST item is the default
 * language. Every dashboard reader takes the default from here (backend twin:
 * `demo/lib/i18n/default_lang.py`).
 */
export const defaultLang = (langs, fallback = undefined) =>
    Array.isArray(langs) && langs.length > 0 ? langs[langs.length - 1] : fallback;
